<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin">
            <span class="loader">
                <span>{{ $spinnerText }}</span>
            </span>
        </div>
    </Transition>

    <v-form :name="props.formProps.formName">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
                <Tab value="1">{{ __('Partial offers') }}</Tab>
                <Tab value="2">{{ __('Attachments') }}</Tab>
                <Tab value="3">{{ __('Changelog') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormInputText fieldName="quotation_name"
                                       label="Quotation name"
                                       validation="required"
                                       :size="isAddMode ? '10' : '8'"
                                       :isFormDisabled="isFormDisabled"
                                       :isFocus="true"
                                       v-model:field="crud.quotation_name" />
                        <template v-if="!isAddMode">
                            <FormInputText fieldName="quotation_number"
                                           label="Number"
                                           size="2"
                                           :isFormDisabled="true"
                                           v-model:field="crud.quotation_number" />
                        </template>

                        <FormSelect fieldName="status_id"
                                    label="Status"
                                    size="2"
                                    :isFormDisabled="true"
                                    :options="select?.statuses"
                                    v-model:field="crud.status_id" />
                    </div>
                    <div class="grid">
                        <FormSelect fieldName="project_id"
                                    label="Project"
                                    size="3"
                                    :isFormDisabled="isFormDisabled || isProjectDisabled"
                                    :options="select?.projects"
                                    v-model:field="crud.project_id" />

                        <FormSelect fieldName="dcttype_id"
                                    label="Type"
                                    size="2"
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.dct_quotation_types"
                                    v-model:field="crud.dcttype_id" />

                        <FormInputNumber fieldName="total_value"
                                         label="Total value"
                                         size="2"
                                         :minFractionDigits="2"
                                         :maxFractionDigits="2"
                                         :isFormDisabled="true"
                                         v-model:field="crud.total_value" />

                        <FormSelect fieldName="creator_id"
                                    label="Creator"
                                    size="3"
                                    :isFormDisabled="true"
                                    :options="select?.users"
                                    v-model:field="crud.creator_id" />

                        <FormCalendar fieldName="creation_date"
                                      label="Creation date"
                                      size="2"
                                      validation="required"
                                      :isFormDisabled="isFormDisabled"
                                      v-model:field="crud.creation_date" />
                    </div>
                    <div class="grid">
                        <FormEditor fieldName="description"
                                    label="Description"
                                    :isFormDisabled="isFormDisabled"
                                    v-model:field="crud.description" />
                    </div>
                </TabPanel>

                <TabPanel value="1">
                    <div class="grid">
                        <div style="overflow-x: auto; padding-bottom: 10px;">
                            <FormRepeaterTable v-model:record="crud.quotation_offers"
                                               :isFirstRowEmpty="true"
                                               :isCopyButton="false"
                                               :isDeleteReplicate="true"
                                               repeaterStyle="margin-top:5px;min-width:120vw"
                                               headerStyle="font-size:11px;vertical-align:center;text-align:center;border-width:1px;"
                                               :keys="{
                                                'offer_id': null, 'assortment_name': null, 'total': null,
                                                'quote_after_start': null, 'date_after_start': null, 'form_after_start': null,
                                                'quote_after_first': null, 'date_after_first': null, 'form_after_first': null,
                                                'quote_after_second': null, 'date_after_second': null, 'form_after_second': null,
                                                'quote_after_measure': null, 'date_after_measure': null, 'form_after_measure': null,
                                                'quote_before_montage': null, 'date_before_montage': null, 'form_before_montage': null,
                                                'quote_after_end': null, 'date_after_end': null, 'form_after_end': null,
                                                'description': null
                                            }"
                                               name="quotation_offers"
                                               :title="[__('Offer name'), __('Assortment name'), __('Total'),
                                            __('Kwota do opłacenia przy uruchomieniu umowy'), __('Data opłacenia'), __('Forma opłacenia'),
                                            __('Kwota do opłacenia po I etapie prac'), __('Data opłacenia'), __('Forma opłacenia'),
                                            __('Kwota do opłacenia po II etapie prac'), __('Data opłacenia'), __('Forma opłacenia'),
                                            __('Kwota do opłacenia po pomiarze'), __('Data opłacenia'), __('Forma opłacenia'),
                                            __('Kwota do opłacenia przy rozpoczęciu montażu'), __('Data opłacenia'), __('Forma opłacenia'),
                                            __('Kwota do opłacenia po zakończeniu zamówienia'), __('Data opłacenia'), __('Forma opłacenia'),
                                            __('Description')]">
                                <template #repeat="slotProps">
                                    <td style="width:250px;"
                                        :style="slotProps.cellStyle">
                                        <FormSelect fieldName="offer_id"
                                                    :inputStyle="{ 'fontSize': '12px' }"
                                                    style="line-height:0.5"
                                                    validation="required"
                                                    labelInInput="offer_name"
                                                    :inRepeater="true"
                                                    :options="select?.offers"
                                                    :change="(e) => setOfferParamsInRepeaterRow(e, slotProps.record)"
                                                    v-model:field="slotProps.record.offer_id" />
                                    </td>
                                    <td style="width:300px"
                                        :style="slotProps.cellStyle">
                                        <FormTextarea fieldName="assortment_name"
                                                      inputStyle="font-size:11px;line-height:1;"
                                                      outerStyle="background-color:transparent !important;"
                                                      :disabled="true"
                                                      :inRepeater="true"
                                                      :rows="2"
                                                      v-model:field="slotProps.record.assortment_name" />
                                    </td>

                                    <td :style="slotProps.cellStyle">
                                        <FormInputNumber fieldName="total"
                                                         :inputStyle="{ 'fontSize': '11px !important', 'width': '90px' }"
                                                         :disabled="true"
                                                         :inRepeater="true"
                                                         :minFractionDigits="2"
                                                         :maxFractionDigits="2"
                                                         v-model:field="slotProps.record.total" />
                                    </td>


                                    <td style="width:110px"
                                        :style="slotProps.cellStyle">
                                        <FormInputNumber fieldName="quote_after_start"
                                                         :inputStyle="{ 'fontSize': '11px !important' }"
                                                         :inRepeater="true"
                                                         :minFractionDigits="2"
                                                         :maxFractionDigits="2"
                                                         :blur="sumOfAllStages"
                                                         v-model:field="slotProps.record.quote_after_start" />
                                    </td>
                                    <td style="width:130px"
                                        :style="slotProps.cellStyle">
                                        <FormCalendar fieldName="date_after_start"
                                                      :inputStyle="{ 'fontSize': '11px !important' }"
                                                      :inRepeater="true"
                                                      v-model:field="slotProps.record.date_after_start" />
                                    </td>
                                    <td style="width:100px"
                                        :style="slotProps.cellStyle">
                                        <FormSelect fieldName="form_after_start"
                                                    :inputStyle="{ 'fontSize': '11px !important' }"
                                                    :inRepeater="true"
                                                    :options="select?.payment_forms"
                                                    v-model:field="slotProps.record.form_after_start" />
                                    </td>


                                    <td style="width:110px"
                                        :style="slotProps.cellStyle">
                                        <FormInputNumber fieldName="quote_after_first"
                                                         :inputStyle="{ 'fontSize': '11px !important', 'width': '70px' }"
                                                         :inRepeater="true"
                                                         :minFractionDigits="2"
                                                         :maxFractionDigits="2"
                                                         :blur="sumOfAllStages"
                                                         v-model:field="slotProps.record.quote_after_first" />
                                    </td>
                                    <td style="width:130px"
                                        :style="slotProps.cellStyle">
                                        <FormCalendar fieldName="date_after_first"
                                                      :inputStyle="{ 'fontSize': '11px !important' }"
                                                      :inRepeater="true"
                                                      v-model:field="slotProps.record.date_after_first" />
                                    </td>
                                    <td style="width:100px"
                                        :style="slotProps.cellStyle">
                                        <FormSelect fieldName="form_after_first"
                                                    :inputStyle="{ 'fontSize': '11px !important' }"
                                                    :inRepeater="true"
                                                    :options="select?.payment_forms"
                                                    v-model:field="slotProps.record.form_after_first" />
                                    </td>


                                    <td style="width:110px"
                                        :style="slotProps.cellStyle">
                                        <FormInputNumber fieldName="quote_after_second"
                                                         :inputStyle="{ 'fontSize': '11px !important', 'width': '70px' }"
                                                         :inRepeater="true"
                                                         :minFractionDigits="2"
                                                         :maxFractionDigits="2"
                                                         :blur="sumOfAllStages"
                                                         v-model:field="slotProps.record.quote_after_second" />
                                    </td>
                                    <td style="width:130px"
                                        :style="slotProps.cellStyle">
                                        <FormCalendar fieldName="date_after_second"
                                                      :inputStyle="{ 'fontSize': '11px !important' }"
                                                      :inRepeater="true"
                                                      v-model:field="slotProps.record.date_after_second" />
                                    </td>
                                    <td style="width:100px"
                                        :style="slotProps.cellStyle">
                                        <FormSelect fieldName="form_after_second"
                                                    :inputStyle="{ 'fontSize': '11px !important' }"
                                                    :inRepeater="true"
                                                    :options="select?.payment_forms"
                                                    v-model:field="slotProps.record.form_after_second" />
                                    </td>


                                    <td style="width:110px"
                                        :style="slotProps.cellStyle">
                                        <FormInputNumber fieldName="quote_after_measure"
                                                         :inputStyle="{ 'fontSize': '11px !important', 'width': '70px' }"
                                                         :inRepeater="true"
                                                         :minFractionDigits="2"
                                                         :maxFractionDigits="2"
                                                         :blur="sumOfAllStages"
                                                         v-model:field="slotProps.record.quote_after_measure" />
                                    </td>
                                    <td style="width:130px"
                                        :style="slotProps.cellStyle">
                                        <FormCalendar fieldName="date_after_measure"
                                                      :inputStyle="{ 'fontSize': '11px !important' }"
                                                      :inRepeater="true"
                                                      v-model:field="slotProps.record.date_after_measure" />
                                    </td>
                                    <td style="width:100px"
                                        :style="slotProps.cellStyle">
                                        <FormSelect fieldName="form_after_measure"
                                                    :inputStyle="{ 'fontSize': '11px !important' }"
                                                    :inRepeater="true"
                                                    :options="select?.payment_forms"
                                                    v-model:field="slotProps.record.form_after_measure" />
                                    </td>

                                    <td style="width:110px"
                                        :style="slotProps.cellStyle">
                                        <FormInputNumber fieldName="quote_before_montage"
                                                         :inputStyle="{ 'fontSize': '11px !important', 'width': '70px' }"
                                                         :inRepeater="true"
                                                         :minFractionDigits="2"
                                                         :maxFractionDigits="2"
                                                         :blur="sumOfAllStages"
                                                         v-model:field="slotProps.record.quote_before_montage" />
                                    </td>
                                    <td style="width:130px"
                                        :style="slotProps.cellStyle">
                                        <FormCalendar fieldName="date_before_montage"
                                                      :inputStyle="{ 'fontSize': '11px !important' }"
                                                      :inRepeater="true"
                                                      v-model:field="slotProps.record.date_before_montage" />
                                    </td>
                                    <td style="width:100px"
                                        :style="slotProps.cellStyle">
                                        <FormSelect fieldName="form_before_montage"
                                                    :inputStyle="{ 'fontSize': '11px !important' }"
                                                    :inRepeater="true"
                                                    :options="select?.payment_forms"
                                                    v-model:field="slotProps.record.form_before_montage" />
                                    </td>


                                    <td style="width:110px"
                                        :style="slotProps.cellStyle">
                                        <FormInputNumber fieldName="quote_after_end"
                                                         :inputStyle="{ 'fontSize': '11px !important', 'width': '70px' }"
                                                         :inRepeater="true"
                                                         :minFractionDigits="2"
                                                         :maxFractionDigits="2"
                                                         :blur="sumOfAllStages"
                                                         v-model:field="slotProps.record.quote_after_end" />
                                    </td>
                                    <td style="width:130px"
                                        :style="slotProps.cellStyle">
                                        <FormCalendar fieldName="date_after_end"
                                                      :inputStyle="{ 'fontSize': '11px !important' }"
                                                      :inRepeater="true"
                                                      v-model:field="slotProps.record.date_after_end" />
                                    </td>
                                    <td style="width:100px"
                                        :style="slotProps.cellStyle">
                                        <FormSelect fieldName="form_after_end"
                                                    :inputStyle="{ 'fontSize': '11px !important' }"
                                                    :inRepeater="true"
                                                    :options="select?.payment_forms"
                                                    v-model:field="slotProps.record.form_after_end" />
                                    </td>

                                    <td style="width:200px"
                                        :style="slotProps.cellStyle">
                                        <FormTextarea fieldName="description"
                                                      inputStyle="font-size:11px;line-height:1;"
                                                      :inRepeater="true"
                                                      :rows="2"
                                                      v-model:field="slotProps.record.description" />
                                    </td>
                                </template>
                                <template #footer="footerProps">
                                    <td v-for="i in footerProps.columns"
                                        :key="i">
                                        <div v-if="i == 3"
                                             style="font-weight: 900; color: red; font-size: 14px; text-align:right;padding-right:15px">
                                            {{ numberFormat(totalOfAllOffers.toFixed(2)) }}
                                        </div>
                                        <div v-if="i == 4"
                                             style="font-weight: 900; color: green; font-size: 14px; text-align:right;padding-right:15px">
                                            {{ numberFormat(sumAfterStart.toFixed(2)) }}
                                        </div>
                                        <div v-if="i == 7"
                                             style="font-weight: 900; color: green; font-size: 14px; text-align:right;padding-right:15px">
                                            {{ numberFormat(sumAfterFirst.toFixed(2)) }}
                                        </div>
                                        <div v-if="i == 10"
                                             style="font-weight: 900; color: green; font-size: 14px; text-align:right;padding-right:15px">
                                            {{ numberFormat(sumAfterSecond.toFixed(2)) }}
                                        </div>
                                        <div v-if="i == 13"
                                             style="font-weight: 900; color: green; font-size: 14px; text-align:right;padding-right:15px">
                                            {{ numberFormat(sumAfterMeasure.toFixed(2)) }}
                                        </div>
                                        <div v-if="i == 16"
                                             style="font-weight: 900; color: green; font-size: 14px; text-align:right;padding-right:15px">
                                            {{ numberFormat(sumBeforeMontage.toFixed(2)) }}
                                        </div>
                                        <div v-if="i == 19"
                                             style="font-weight: 900; color: green; font-size: 14px; text-align:right;padding-right:15px">
                                            {{ numberFormat(sumAfterEnd.toFixed(2)) }}
                                        </div>

                                    </td>
                                </template>

                            </FormRepeaterTable>
                        </div>
                    </div>
                </TabPanel>

                <TabPanel value="2">
                    <div class="grid">
                        <FormFileUploader fieldName="files"
                                          label="Documents"
                                          category="documents"
                                          :allowedExtensions="['pdf', 'docx', 'xlsx', 'txt']"
                                          :style="{ minWidth: '200px' }"
                                          :isFormDisabled="isFormDisabled"
                                          v-model:field="crud.files" />
                        <FormFileUploader fieldName="files"
                                          label="Pictures"
                                          category="pictures"
                                          imgPosition="right"
                                          :allowedExtensions="['jpg', 'jpeg', 'png', 'gif']"
                                          :style="{ minWidth: '200px' }"
                                          :isFormDisabled="isFormDisabled"
                                          v-model:field="crud.files" />
                    </div>
                </TabPanel>

                <TabPanel v-if="crud.log"
                          value="3"
                          :pt="{ root: { class: 'form-tab-panel' } }">
                    <ChangeLog :log="crud?.log" />
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         v-model:isFormDisabled="isFormDisabled">

                <template #after-in-show="buttonProps">
                    <span style="margin-right:25px"></span>
                    <span v-if="!isApproved">
                        <CustomButton name="setApproved"
                                      @click.stop="isSetApprovedStatusConfirmationOpen = true"
                                      :buttonProps="buttonProps"
                                      :className="buttonClass('blue')">
                            <template class="flex items-center gap-1"><i class="fa-solid fa-check-double"></i><span>{{ __('Make approve') }}</span></template>
                        </CustomButton>
                    </span>
                    <span v-if="isApproved">
                        <CustomButton name="removeApproved"
                                      @click.stop="isRemoveApprovedStatusConfirmationOpen = true"
                                      :buttonProps="buttonProps"
                                      :className="buttonClass('blue')">
                            <template class="flex items-center gap-1"><i class="fa-solid fa-check-double"></i><span>{{ __('Remove approve') }}</span></template>
                        </CustomButton>
                    </span>

                </template>

                <template #after-in-edit>
                    <AlertAddButton :addAlert="addAlert" />
                </template>
            </FormButtons>
        </div>

        <AlertAdd :formProps="{ source_table: 'quotations', source_id: crud.id, width: '50%' }"
                  v-model:isAddAlertDialogOpen="isAddAlertDialogOpen" />
    </v-form>

    <ConfirmDialog header="Confirm operation"
                   question="Do you want to set Approved status?"
                   v-model="isSetApprovedStatusConfirmationOpen"
                   :operation="setApprovedStatus">
    </ConfirmDialog>

    <ConfirmDialog header="Confirm operation"
                   question="Do you want to remove Approved status?"
                   v-model="isRemoveApprovedStatusConfirmationOpen"
                   :operation="removeApprovedStatus">
    </ConfirmDialog>

</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue'
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import FormStaticText from '@crud/FormStaticText.vue'
import FormInputNumber from '@crud/FormInputNumber.vue'
import FormSelect from '@crud/FormSelect.vue'
import FormCalendar from '@crud/FormCalendar.vue'
import FormRepeaterTable from '@crud/FormRepeaterTable.vue'
import FormTextarea from '@crud/FormTextarea.vue'
import FormEditor from '@crud/FormEditor.vue'
import FormFileUploader from '@crud/FormFileUploader.vue'
import FormButtons from '@crud/FormButtons.vue'
import ChangeLog from '@crud/ChangeLog.vue'
import ConfirmDialog from '@crud/ConfirmDialog.vue'
import CustomButton from '@crud/CustomButton.vue'
import AlertAdd from '@app/Data/Alert/AlertAdd.vue'
import AlertAddButton from '@alert/AlertAddButton.vue'
import { validation, initFormObj } from '@pages/Helper/crud_utils.js'
import { __, currentDate, getStoreValue, getStatusId, numberFormat, buttonClass, getFromRoute, screenMessage, getAllStatuses } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
})

const isLoading = ref(true);
const isFormDisabled = ref(true)
const crud = ref({})

const options = ["statuses", "projects", "quotations", "dct_quotation_types", "offers", "payment_forms", "users"];
const select = ref(null);
const isAddAlertDialogOpen = ref(false);
const isProjectDisabled = ref(false);
const totalOfAllOffers = ref(0);
const sumAfterStart = ref(0)
const sumAfterFirst = ref(0)
const sumAfterSecond = ref(0)
const sumAfterMeasure = ref(0)
const sumBeforeMontage = ref(0)
const sumAfterEnd = ref(0)
const isAddMode = props.formProps.addMode
const isSetApprovedStatusConfirmationOpen = ref(false);
const isRemoveApprovedStatusConfirmationOpen = ref(false);
const isApproved = ref(false);
const isRegistered = ref(false);

// -----------------------------------------------------

onMounted(async () => {
    await initFormObj({ props, crud, isLoading, options, select, paramsToSelect: { 'statuses': { 'status_category': 'STA_QUOTATION' } } })
    let allStatuses = await getAllStatuses('STA_QUOTATION');
    isApproved.value = crud.value.status_id == allStatuses.find(s => s.status_symbol == 'SYM_APPROVED')?.id;
    isRegistered.value = crud.value.status_id == allStatuses.find(s => s.status_symbol == 'SYM_REGISTERED')?.id;

    if (props.formProps.addMode == true) {
        crud.value.creator_id = getStoreValue('myId');
        crud.value.status_id = allStatuses.find(s => s.status_symbol == 'SYM_REGISTERED')?.id; // await getStatusId('STA_QUOTATION', 'SYM_REGISTERED');
        crud.value.creation_date = currentDate()
    }
    sumOfAllStages()

    if (props.formProps.viewParams?.project_id) {
        crud.value.project_id = props.formProps.viewParams.project_id;
        isProjectDisabled.value = true;
    }
})

// -----------------------------------------------------

const setOfferParamsInRepeaterRow = (selectedOffer, record) => {
    const offer = select.value.offers.find(o => o.value === selectedOffer.value);
    if (offer) {
        record.assortment_name = offer.assortment_name;
        record.total = offer.total;
    }

    sumOfAllStages()
}

// -----------------------------------------------------

const sumOfAllStages = () => {
    nextTick(() => {
        totalOfAllOffers.value = sumAfterStart.value = sumAfterFirst.value = sumAfterSecond.value = sumAfterMeasure.value = sumBeforeMontage.value = sumAfterEnd.value = 0;
        crud.value?.quotation_offers?.forEach((offer) => {
            totalOfAllOffers.value += parseFloat(offer.total) || 0;
            sumAfterStart.value += parseFloat(offer.quote_after_start) || 0
            sumAfterFirst.value += parseFloat(offer.quote_after_first) || 0
            sumAfterSecond.value += parseFloat(offer.quote_after_second) || 0
            sumAfterMeasure.value += parseFloat(offer.quote_after_measure) || 0
            sumBeforeMontage.value += parseFloat(offer.quote_before_montage) || 0
            sumAfterEnd.value += parseFloat(offer.quote_after_end) || 0
        })

        crud.value.total_value = totalOfAllOffers.value;
    })
}

// -----------------------------------------------------

const setApprovedStatus = async () => {
    const response = await getFromRoute('quotation-set-approved', { quotation_id: crud.value.id }, 'post');
    if (response.success) {
        const message = {
            message: response.message,
            title: "Success",
            type: "success",
            position: "center",
            timeout: 5,
        };
        screenMessage(message);
        crud.value.status_id = response.new_status_id; // Aktualizacja statusu w formularzu
    } else {
        const message = {
            message: response.message || "An error occurred",
            title: "Error",
            type: "error",
            position: "center",
            timeout: 5,
        };
        screenMessage(message);
    }

    props.formProps.closeModal();
    props.formProps.getLazyData();
}

// -----------------------------------------------------

const removeApprovedStatus = async () => {
    const response = await getFromRoute('quotation-remove-approved', { quotation_id: crud.value.id }, 'post');
    if (response.success) {
        const message = {
            message: response.message,
            title: "Success",
            type: "success",
            position: "center",
            timeout: 5,
        };
        screenMessage(message);
        crud.value.status_id = response.new_status_id; // Aktualizacja statusu w formularzu
    } else {
        const message = {
            message: response.message || "An error occurred",
            title: "Error",
            type: "error",
            position: "center",
            timeout: 5,
        };
        screenMessage(message);
    }

    props.formProps.closeModal();
    props.formProps.getLazyData();
}

// -----------------------------------------------------

const addAlert = async () => {
    isAddAlertDialogOpen.value = true;
}

// -----------------------------------------------------


</script>

<style lang="scss" scoped></style>
